import React, { useState, useEffect } from "react";
import { FaArrowCircleUp } from "react-icons/fa";
import "../styles/BackToTop.css";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const footerHeight = document.querySelector("footer")?.offsetHeight || 0;

      // Show button after scrolling down 300px
      setIsVisible(scrolled > 300);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={`back-to-top ${isVisible ? "visible" : ""}`}>
      <button
        onClick={scrollToTop}
        aria-label="Back to top"
        className="back-to-top-float"
      >
        <FaArrowCircleUp />
      </button>
    </div>
  );
};

export default BackToTop;
